import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";

export interface ICouponserviceCategoryResponseData {
  id: string;
  category_name: string;
  created_at: string;
  updated_at: string;
}
export interface ICouponserviceCategoryResponse {
  status: boolean;
  message: string;
  data: ICouponserviceCategoryResponseData[];
}
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});

export const useCouponCategoryAPI = () => {
  const [serviceCategory, setServiceCategory] = useState<ICouponserviceCategoryResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: InventoryTaxCreateAPIResponse = await axios
        .get(COUPON_SERVICE_APIS?.COUPON_VMS_CATEGORY?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICouponserviceCategoryResponse>) => {
          if (res.data.status) {
            setServiceCategory(res.data.data);
            return { status: true, message: null };
            //
          } else {
            setServiceCategory([]);
            return { status: false, message: null };
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            setServiceCategory([]);
            //   toast.error("Error while fetching List details");
          }
          if (e.status === 400) {
            setServiceCategory([]);
            //   toast("Product records not found");
          }

          if (e.response.status === 500) {
            setServiceCategory([]);
            // toast.error("Server error 500");
          }
          return { status: false, message: null };
        });
      return response;
    } catch (e: any) {
      // toast.error("Server Error: " + e.message);
      setServiceCategory([]);
    }
  }, [dispatch]);
  return { execute, serviceCategory };
};
